import styled from "@emotion/styled";
import { Button, Typography } from "@trustpilot/businessapp-patternlibrary";
import { Card as ConstellationCard } from "@trustpilot/constellation-components";
import { useTranslations } from "ilenia";

import errorIllustration from "./error-illustration.png";

const Card = styled(ConstellationCard)`
  display: flex;
  flex-direction: column;
  margin: var(--CDS-spacing-xxxl) auto;
  row-gap: var(--spacing-xl);
  padding: var(--spacing-xl);

  @media (min-width: 768px) {
    align-items: center;
    padding: 100px var(--spacing-xxl);
    margin: 100px auto;
    max-width: 1040px;
    column-gap: var(--spacing-xxl);
    flex-direction: row;
  }
`;

const ErrorImage = styled.img`
  width: 100%;
  max-width: 322px;
  margin: 0 auto;

  @media (min-width: 768px) {
    flex-basis: 50%;
  }
`;

const ErrorInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-l);
  max-width: 570px;
`;

const Wrapper = styled.div`
  @media (min-width: 768px) {
    max-width: 400px;
  }
`;

const ErrorComponent = () => {
  const [translations] = useTranslations();
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Card>
      <ErrorImage src={errorIllustration} alt={translations["FallbackPages.genericerror.imageAltText"]} />
      <ErrorInfo>
        <Wrapper>
          <Typography variant="display-m">{translations["FallbackPages.genericerror.header"]}</Typography>
        </Wrapper>
        <Typography variant="body-l">{translations["FallbackPages.genericerror.subText"]}</Typography>
        <Wrapper>
          <Button onClick={handleRefresh} appearance="primary" size="xl" stretch>
            {translations["FallbackPages.genericerror.button"]}
          </Button>
        </Wrapper>
      </ErrorInfo>
    </Card>
  );
};

export default ErrorComponent;
